import styles from './ShowAllToggle.module.css';

/** "Show all 21" / "Show fewer" under a list that starts trimmed. */
export function ShowAllToggle({
  total,
  expanded,
  onToggle,
  controls,
}: {
  total: number;
  expanded: boolean;
  onToggle: () => void;
  /** id of the list it expands. */
  controls: string;
}) {
  return (
    <button
      type="button"
      className={styles.toggle}
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={onToggle}
    >
      {expanded ? 'Show fewer' : `Show all ${total}`}
    </button>
  );
}
